export default __webpack_public_path__ + "static/media/hopes-and-fears-01.795748e2.jpg";